import { GpsFixed, PlayCircleOutline, Visibility } from "@mui/icons-material";
import { Button, ButtonBase, Fab, Skeleton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import customProtocolCheck from "custom-protocol-check";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Popup } from "react-leaflet";
import { addProtocol } from "Utils/addProtocol";
import { useMap, useWiviContent } from "Utils/hooks";

const LeafletPopup = ({ position, data, target }) => {
  const { t } = useTranslation();
  const { geolocation, configuration } = useMap();
  const googlTravelModes = {
    foot: "walking",
    bike: "bicycling",
    car: "driving",
  };
  const {
    data: fetch,
    loading,
    error,
    title,
    audioGuideTracks,
  } = useWiviContent({ ...data, id: target?.id, type: target?.type });

  const image = useMemo(() => {
    const url = fetch?.image?.formats.filter((i) => i.name === "xs")[0].file
      .url;
    return url;
  }, [fetch]);

  const handleGPS = () => {
    const geoLink = `geo:${position.y},${position.x};u=35`;
    const pathWayType = data?.pathWayType
      ? googlTravelModes[data?.pathWayType]
      : googlTravelModes["foot"];

    // si geolocation reconnue on propose un itinéraire dans google maps autrement on indique juste la position du point
    const mapsUrl = geolocation
      ? `https://www.google.com/maps/dir/?api=1&origin=${geolocation.lat},${geolocation.lng}&destination=${position.y},${position.x}&travelmode=${pathWayType}`
      : `https://www.google.com/maps/search/?api=1&query=${position.y}%2C${position.x}`;
    //adapte l'ouverture d'url en fonction du navigateur et la disponibilité du protocole geo
    customProtocolCheck(geoLink, () => window.open(mapsUrl), null, 500);
  };

  const handleAudioGuide = () => {
    target = {
      type: "audioGuideTracks",
      audioGuideTracks,
      pointOfInterest: data,
    };
    window.parent.postMessage(target, "*");
  };

  const handleTarget = () => {
    const { id, type } = data?.target ?? {};
    console.log(data?.target);
    switch (type) {
      case "collection":
      case "url":
      case "pointOfInterest":
        return window.parent.postMessage(data?.target, "*"); // window.parent.goTo(data?.target);
      //   case "mapLink":
      //     return navigate(pathname === "/outdoor" ? "/" : "/outdoor");
      //   case "layerLink":
      //     return setActualLayer(id);
      default:
        return null;
    }
  };

  return (
    <Popup direction="top" style={{ padding: 0 }}>
      <Box display="flex" p={0} flexDirection="row" gap={1} w="full" h="full">
        {!loading && image && (
          <ButtonBase
            style={{
              backgroundColor: "red",
              flex: 1,
            }}
            onClick={handleTarget}
          >
            <Box
              backgroundColor="primary.main"
              height="fill-available"
              display="flex"
              px={2}
              alignItems="center"
              justifyContent="center"
              sx={{
                backgroundImage: `url(${addProtocol(image)})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <Fab
                size="small"
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.5)",
                  color: "primary.main",
                  backdropFilter: "blur(10px)",
                }}
              >
                <Visibility />
              </Fab>
            </Box>
          </ButtonBase>
        )}
        <Box
          display="flex"
          h="full"
          flexDirection="column"
          gap={0.5}
          pl={2}
          alignItems="start"
          justifyContent="space-between"
          py={1}
          width="max-content"
        >
          <Box mr={12}>
            {!loading ? (
              <Typography
                style={{ margin: 0 }}
                sx={{
                  padding: 0,
                  fontWeight: "600",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {title}
              </Typography>
            ) : (
              <Skeleton variant="text" width="100%" height="100%" />
            )}

            {configuration?.showGpsLinks ? (
              <ButtonBase
                onClick={handleGPS}
                sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
              >
                <Typography variant="caption">
                  {t("/outdoor.openGPS")}
                </Typography>
                <GpsFixed sx={{ fontSize: "1rem", color: "primary.main" }} />
              </ButtonBase>
            ) : null}
          </Box>
          {configuration?.showAudioGuidePlayButton &&
            audioGuideTracks?.length > 0 && (
              <ButtonBase
                sx={{
                  alignSelf: "end",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
                onClick={handleAudioGuide}
              >
                <Typography
                  variant="body2"
                  fontWeight="600"
                  style={{ margin: 0 }}
                >
                  {t("/outdoor.readAudioGuide")}
                </Typography>
                <PlayCircleOutline
                  sx={{ fontSize: "1.2rem", color: "primary.main" }}
                />
              </ButtonBase>
            )}
          {((!configuration?.showAudioGuidePlayButton &&
            !configuration?.showGpsLinks) ||
            target?.type === "url") && (
            <Button
              variant="outlined"
              size="small"
              endIcon={<Visibility />}
              onClick={handleTarget}
            >
              {t("/outdoor.openPOI")}
            </Button>
          )}
        </Box>
      </Box>
    </Popup>
  );
};

export default LeafletPopup;
